import React from 'react';
import { DatasourceInfo } from './Datasource/DatasourceInfo';
import { StationInfo } from './Station/StationInfo';

type SourceInfoProps = {
  stationId?: number,
  datasourceId?: number
};

export const SourceInfo = ({ stationId, datasourceId }: Partial<SourceInfoProps>) => {
  if (datasourceId) {
    return <DatasourceInfo datasourceId={datasourceId} />;
  }
  if (stationId) {
    return <StationInfo stationId={stationId} />;
  }
  return null;
};
